import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { KeyRound, Lock, ShieldCheck, Sparkles } from "lucide-react";

export const Route = createFileRoute("/security/secrets")({
  component: SecretsVault,
});

function SecretsVault() {
  return (
    <div className="space-y-4 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
          <KeyRound className="h-5 w-5" /> Coffre-fort secrets
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">HSM · Rotation automatique · Audit complet</p>
      </div>

      <div className="rounded-lg border border-indigo-500/30 bg-indigo-500/5 p-3 flex items-start gap-2 text-sm">
        <Sparkles className="h-4 w-4 text-indigo-400 mt-0.5" />
        <div>
          <strong>Disponible en v7.0</strong> · Intégration HSM + Vault + rotation automatique.
          Pour l'instant, les secrets sont gérés via <code>.env.supabase</code> (gitignored).
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><ShieldCheck className="h-4 w-4" /> État actuel</CardTitle>
        </CardHeader>
        <CardContent className="space-y-2 text-sm">
          <Row label="JWT signing" value="HS256 (legacy secret)" badge="active" />
          <Row label="Password hashing" value="Argon2id" badge="active" />
          <Row label="Refresh tokens" value="SHA-256 hash chain" badge="active" />
          <Row label="API keys" value="env variables (gitignored)" badge="active" />
          <Row label="Database encryption at rest" value="Supabase managed" badge="active" />
          <Row label="Field-level encryption (PHI)" value="—" badge="v7" />
          <Row label="HSM-backed key custody" value="—" badge="v7" />
          <Row label="Automatic secret rotation" value="—" badge="v7" />
        </CardContent>
      </Card>
    </div>
  );
}

function Row({ label, value, badge }: { label: string; value: string; badge: string }) {
  return (
    <div className="flex items-center justify-between border-b border-white/5 pb-1.5">
      <span className="text-muted-foreground">{label}</span>
      <div className="flex items-center gap-2">
        <span className="font-mono text-xs">{value}</span>
        <Badge variant={badge === "active" ? "secondary" : "outline"} className="text-[10px]">{badge}</Badge>
      </div>
    </div>
  );
}
